import { RadioGroup as ChakraRadioGroup, RadioGroupProps } from '@chakra-ui/react';

export type { RadioGroupProps };

/**
 * RadioGroup component to help manage Radio components and conveniently pass a few shared style props to each.
 * Composes Box.
 */
const RadioGroup = (props: RadioGroupProps) => {
  return <ChakraRadioGroup {...props} />;
};

export default RadioGroup;
